module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4e1Pp"))).then(() => parcelRequire('fThBo'));